<template>
  <div class="propertyCreditScoreSystem">
    <!-- 添加表格 -->
      <el-card>
        <div class="jump-btn">
          <el-button type="primary" slot="header" @click="jump()">{{$t('lang.btn_returnPropertyCreditScoreSys')}}</el-button>
        </div>
        <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName">
          <!-- 序号 -->
          <el-table-column prop="id" :label="$t('lang.lab_id')"></el-table-column>
          <!-- 评价等级 -->
          <el-table-column prop="level" :label="$t('lang.lab_rating')"></el-table-column>
          <!-- 操作 -->
          <el-table-column :label="$t('lang.lab_operation')" fixed="right" :width="require('@/config/enum').opr_width1">
            <template slot-scope="scope">
              <el-button @click="edit(scope.row.id)">{{$t('lang.btn_detail')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
</template>

<script>
/**
 *@ClassName:communityManagement
 *@Description:物业信用积分体系
 *@author:李斌
 *@Copyright:格众科技
 *@date:2020-02-25
 */
export default {
  // 默认显示数据
  data() {
    return {
      tableData: this.$i18n.t('lang.PROPERTYCREDITSCORESYS.DETAILS')
    }
  },
  methods: {
    // 列表斑马线
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 跳转到评价页面
    edit(id) {
      this.$router.push({
        name: 'propertyCreditScoreEvaluation',
        query: { id: id }
      })
    },
    // 跳转回列表页面
    jump() {
      this.$router.push({ name: 'propertyCreditScoreList' })
    }
  }
}
</script>

<style lang= 'scss' >
</style>